import { useCallback, useState } from 'react';

/**
 *
 * A state hook to toggle a value on or off
 *
 */
const useToggle = (initialValue = false) => {
  const [value, setValue] = useState(Boolean(initialValue));

  const toggle = useCallback(() => {
    setValue(v => !v);
  }, [setValue]);

  return [value, toggle] as const;
};

export default useToggle;
